import React, { Component } from "react";
import { Accessor, ColorX, DownloadX, GFunc, LocaleX, ReqX, ZTime } from "IZOX/STATIC";
import { ActivityIndicator, HStack, Spacer, VStack, XButton, XDiv, XScroll, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { IoClose } from "react-icons/io5";
import PolicyUtils from "shared/_utils/PolicyUtils";

/**
 * Read-only ACP detail for agents.
 * @augments {Component<Props, State>}
 */
class ViewACP extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      loading: false,
      doc: null
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetDoc();
    });
  }

  componentDidUpdate(prevProps){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ViewACP.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetDoc = async () => {
    let {docID, doc} = this.props;
    if(doc){
      this.setState({ doc });
      return;
    }
    this.setState({ loading: true });
    let res = await ReqX.SendBE("/Web/Agent/GetACP", { docID });
    let {Success, payload} = res;
    this.setState({ loading: false });
    if(Success){
      this.setState({ doc: payload });
    }else{
      GFunc.Alert(payload, "error");
    }
  }

  _download = async () => {
    let {docID} = this.props;
    let id = docID || this.state.doc?._id;
    if(!id) return;
    try{
      GFunc.Loading(true);
      let res = await ReqX.SendBE("/Web/Agent/DownloadACP", { docID: id });
      let {Success, payload} = res;
      if(Success){
        await DownloadX.PDF(payload, payload?.filename || `${id}.pdf`);
      }else{
        GFunc.Alert(payload, "error");
      }
    }finally{
      GFunc.Loading(false);
    }
  }

  renderRow(label, value){
    return (
      <HStack fullWidth HAlign="[" spacing={10} pV={4}>
        <XText bold width={160}>
          {LocaleX.Parse(label)}
        </XText>
        <XText color={ColorX.CSS("Axit")} overflowWrap="anywhere">
          {value ?? "-"}
        </XText>
      </HStack>
    );
  }

  render(){
    let {doc, loading} = this.state;

    if(loading || !doc){
      return (
        <VStack bgColor={ColorX.CSS("pureWhite")} width={560} style={{ maxWidth: "95vw" }} p={20} round={10}>
          <ActivityIndicator loading={true}/>
        </VStack>
      );
    }

    let {_id, status, issueAt, startAt, endAt, netPaid, fromPolicy, _maid, _policy} = doc;
    let _status = PolicyUtils.GetStatus(status);
    let helperName = _maid?.fullName ?? "";
    let policyNo = _policy?.policyNo || doc.policyID || "";

    return (
      <VStack bgColor={ColorX.CSS("pureWhite")} width={560} style={{ maxWidth: "95vw" }} p={20} round={10} spacing={12} HAlign="[">
        <HStack fullWidth>
          <XText bold fontSize={18} color={ColorX.CSS("Leaf")}>
            {LocaleX.Parse({ EN: "ACP Detail", TC: "ACP 詳情" })}
          </XText>
          <Spacer/>
          <XButton onPress={() => GFunc.CloseBackdrop()}>
            <IoClose color={ColorX.CSS("Blood")}/>
          </XButton>
        </HStack>

        <HStack fullWidth HAlign="[" spacing={10}>
          <XText bold>
            {LocaleX.Parse({ EN: "ACP No.", TC: "ACP 編號" })}
          </XText>
          <XText bold color={ColorX.CSS("Axit")}>{_id}</XText>
          <Spacer/>
          {_status &&
            <XDiv bgColor={_status.bgColor} pH={8} pV={2} round={4}>
              <XText color={_status.color} fontSize={12}>
                {LocaleX.Parse(_status.label)}
              </XText>
            </XDiv>
          }
        </HStack>

        <XScroll fullWidth style={{ maxHeight: 360 }}>
          <VStack fullWidth HAlign="[" spacing={2}>
            {this.renderRow({ EN: "Helper", TC: "助理" }, helperName)}
            {this.renderRow({ EN: "Policy No.", TC: "保單編號" }, policyNo)}
            {this.renderRow({ EN: "Source", TC: "來源" }, LocaleX.Parse(fromPolicy
              ? { EN: "From Policy", TC: "來自保單" }
              : { EN: "Manual", TC: "手動新增" }))}
            {this.renderRow({ EN: "Issue Date", TC: "簽發日期" }, issueAt ? ZTime.Moment(issueAt).format("DD MMM YYYY") : "-")}
            {this.renderRow({ EN: "Period From", TC: "保險期由" }, startAt ? ZTime.Moment(startAt).format("DD MMM YYYY") : "-")}
            {this.renderRow({ EN: "Period To", TC: "保險期至" }, endAt ? ZTime.Moment(endAt).format("DD MMM YYYY") : "-")}
            {this.renderRow({ EN: "Net Paid", TC: "淨支付" }, netPaid != null ? String(netPaid) : "-")}
          </VStack>
        </XScroll>

        <HStack fullWidth HAlign="]" spacing={10}>
          <XButton onPress={this._download}
            bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
            pH={20} padding={8} round={6}>
            <XText bold fontSize={13}>
              {LocaleX.Parse({ EN: "Download ACP", TC: "下載 ACP" })}
            </XText>
          </XButton>
        </HStack>
      </VStack>
    );
  }

}

export default ViewACP;
